// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconArrowLeft.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconArrowLeft = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M3.26628 8.67691C2.91124 8.32782 2.91124 7.76184 3.26628 7.41276C3.62132 7.06367 4.19695 7.06367 4.55199 7.41276L11.7337 14.474C12.0888 14.8231 12.0888 15.3891 11.7337 15.7382C11.3787 16.0873 10.803 16.0873 10.448 15.7382L3.26628 8.67691Z" />
    <path d="M10.448 0.261813C10.803 -0.0872727 11.3787 -0.0872727 11.7337 0.261813C12.0888 0.610899 12.0888 1.17688 11.7337 1.52596L4.552 8.58724C4.19696 8.93633 3.62133 8.93633 3.26629 8.58724C2.91125 8.23816 2.91125 7.67217 3.26629 7.32309L10.448 0.261813Z" />
  </BaseIcon>
);

export default IconArrowLeft;
